import React, { useState } from "react";
import { TableRow, TableCell } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { getDateData } from "../../helpers/dateHelper";
import { getDollarValue } from "../../helpers/currency";
import { FOUNDRIES } from "../../constants/industry";

import CustomerOrdersJobs from "./CustomerOrdersJobs";
import CustomerOrderContextMenu from "./CustomerOrderContextMenu";
import { HubIcon } from "../../components";
import { StyledChevronCell } from "./styles";

const CustomerOrderRow = ({
  order,
  includeCustomer = false,
  setDeletingId = () => {},
}) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const foundry = FOUNDRIES?.find((f) => f?.id === order?.location)?.label;

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setOpen((prev) => !prev);
  };

  const handleCustomerClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    navigate(`/customers/${order?.customer?.id}`);
  };

  const handlePOClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`/orders/${order?.id}`);
  };

  return (
    <>
      <TableRow
        key={order.id}
        sx={{
          transition: "background-color 0.12s ease",
          ...(open && {
            backgroundColor: "hubColors.mainFocusLightest",
          }),
        }}
      >
        <TableCell variant="small" onClick={onClick} sx={{ cursor: "pointer" }}>
          <StyledChevronCell open={open}>
            <HubIcon icon="ChevronRight" size="12px" />
          </StyledChevronCell>
        </TableCell>
        {includeCustomer && (
          <TableCell variant="blueBold">
            <span onClick={handleCustomerClick}>{order?.customer?.name}</span>
          </TableCell>
        )}
        <TableCell variant="blueBold">
          <span onClick={handlePOClick}>{order.poNumber}</span>
        </TableCell>
        <TableCell>{order.parts}</TableCell>
        <TableCell>{order.status}</TableCell>
        <TableCell>{foundry}</TableCell>
        <TableCell>{getDollarValue(order.revenue)}</TableCell>
        <TableCell>
          {getDateData({ startDate: order.createdAt, includeYear: true })}
        </TableCell>
        <TableCell padding="checkbox">
          <CustomerOrderContextMenu
            id={order.id}
            setDeletingId={setDeletingId}
          />
        </TableCell>
      </TableRow>
      <CustomerOrdersJobs id={order.id} isOpen={open} />
    </>
  );
};

export default CustomerOrderRow;
